<template>
  <div class="my-banner">
    <div class="box-banner">
      <div class="banner-img" style="display: flex;justify-content: space-between;align-items: center;">
        <div><img src="./../static/logo_pf.png" alt="电子招投标交易平台" style="height: 85px;margin-top: -20px;"></div>
        <div style="display: flex;align-items: center;">
          <div style="display: flex;align-items: center;"><img src="./../static/px-banner.png" alt="" style="width: 280px;"></div>
          <div class="line"></div>
          <div style="display: flex;align-items: center;"><img src="./../static/text-banner.png" alt="" style="width: 218px;"></div>
        </div>
      </div>
    </div>
    <div class="banner-banner">
      <div class="banner-list">
        <div class="banner-text" :class="{ 'active': index == vaNum }" v-for="(item,index) in bannerArr" :key="item.id" @click="Jump(item,index)">
          {{ item.categoryName }}
          <div v-if="props.propPage">
            <div class="bottom-line" v-if="index==0"></div>
          </div>
          <div v-else>
            <div class="bottom-line" v-if="index==vaNum"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, defineProps } from 'vue';
import { useRouter } from "vue-router";
import { getAllNavList } from "@/api/index.js"
const props = defineProps({
  propPage: {
    type: String, 
    required: false, 
    default: '' 
  }
});
let router = useRouter()
let bannerArr = ref([])
let vaNum = ref(null)
let Jump = (row, index) => {
  if (row.categoryType == 3) {
    window.open(row.link, '_blank')
  } else {
    sessionStorage.setItem('count', index);
    router.push({ path: row.link })
  }
}
onMounted(async () => {
  vaNum.value = sessionStorage.getItem('count') ? sessionStorage.getItem('count') : 0
  await getAllNavList().then(res => {
    bannerArr.value = res.data
  })
})
</script>
<style scoped>
.line {
  width: 2px;
  height: 50px;
  background: rgb(0, 95, 46);
  margin: 0 28px;
}
.bottom-line {
  width: 72px;
  height: 4px;
  background: rgb(255, 255, 255);
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}
.my-banner {
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.box-banner {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.banner-img {
  width: 1300px;
  height: 130px;
  display: flex;
  align-items: center;
}
.banner-banner {
  width: 100%;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 95, 46, 1);
  box-shadow: 0px 1px 2px rgba(60, 64, 67, 0.5),
    0px 2px 6px 2px rgba(60, 64, 67, 0.5);
}
.banner-list {
  width: 1300px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.banner-text {
  width: 100%;
  height: 100%;
  line-height: 70px;
  text-align: center;
  font-size: 20px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  cursor: pointer;
  position: relative;
}
.banner-text::after {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  width: 2px;
  height: 24px;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.7);
}
.banner-text:last-child::after {
  content: none;
}
.lines:before {
  content: "";
  display: block;
  width: 1px;
  height: 40px;
  background: #aaaaaa;
  position: absolute;
  left: -15px;
  top: 8px;
}
.active {
  font-weight: 700 !important;
}
</style>